module.exports = __webpack_public_path__ + "static/media/ic_warning.5b5d9021.svg";